const dashboard = {
  dashboard: {
    title: 'Dashboard',
    switchToClassic: 'Passa alla visualizzazione classica',
    comingSoon: 'Disponibile prossimamente',
    companyScoreCard: 'Scheda di valutazione del rendimento aziendale',
    enphaseSince: 'Installazione di Enphase da',
    sitesCommissioned: 'Siti messi in servizio',
    microinverters: 'Microinverter installati',
    batteriesInstalled: 'Batterie installate',
    nps: 'Net Promoter Score',
    ensembleCertified: 'Società addetta all’installazione autorizzata all’accumulo',
    einLearn: 'Maggiori informazioni su EIN',
    yes: 'Sì',
    no: 'No',
    lastMonth: {
      one: "nell'ultimo mese",
      other: 'negli ultimi %{count} mesi'
    },
    congratulations: 'Congratulazioni!',
    acceptInvitation: 'Accetta invito',
    einInvitation: "Hai ricevuto l'invito a parte dell'Enphase Installer Network.",
    leadsInvitation: "Hai ricevuto l'invito a parte del programma Enphase Leads.",
    announcements: 'Annunci',
    systems: 'Sistemi',
    all: 'Tutti',
    alerts: 'Avvisi',
    activations: 'Attivazioni',
    leads: 'Lead',
    search: 'Cerca',
    noResult: 'Nessun risultato trovato',
    viewActivations: 'Visualizza tutte le attivazioni',
    viewLeads: 'Visualizza tutti i lead',
    viewSystems: 'Visualizza tutti i sistemi',
    addNewSystems: 'Aggiungi nuovo sistema',
    total: 'Totale',
    activatedSites: 'Siti attivati',
    nameId: 'Nome/ID',
    status: 'Stato',
    city: 'Città',
    state: 'Stato / Prov',
    //TODO - new translation added
    leadSource: 'Lead Source',
    createNewLead: 'Create New Lead',
    //TODO ends
    notAvailable: 'Non disponibile',
    quickAccess: 'Accesso rapido',
    contactUs: 'Contattaci',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Scorciatoie ai servizi',
    newsletter: 'Newsletter per installatori',
    service: 'Responsabile dei servizi',
    enphaseleads: 'Enphase Leads Program',
    enphaseCommunity: 'Community Enphase',
    enphaseStore: 'Negozio Enphase',
    systemConfigurator: 'Configuratore di sistema',
    criticalUpdates: 'Aggiornamenti critici',
    documentation: 'Documentazione',
    brandLibrary: 'Libreria degli brand',
    training: 'Formazione',
    newsBoard: 'Bacheca Novità',
    noContentAvailable: 'Nessun contenuto disponibile',
    viewEinDashboard: 'Visualizza dashboard EIN',
    enterComments: 'Inserisci i tuoi commenti',
    maxAllowedComment: 'Sono consentiti al massimo %{maxCount} caratteri',
    switchingBackNote:
      'Vuoi tornare alla versione classica di Enlighten Manager? Aiutaci a migliorare la nuova versione condividendo il motivo per cui preferisci tornare alla versione precedente',
    switchBackTitle: 'Passa alla visualizzazione classica per un periodo di tempo limitato',
    new: 'Nuovo',
    view: 'Visualizza',
    gridProfileToken: 'Token di modifica del profilo rete',
    ProfileTokenText: 'Token di modifica del profilo',
    validText: 'Questo token è valido per Envoy %{serialNumber} per un giorno.',
    envoySerialNumber: 'Numero di serie di Envoy',
    authorizationNumber: 'Numero di autorizzazione',
    getToken: 'Ottieni token',
    viewAll: 'Visualizza tutto',
    viewFullList: `Visualizza l'elenco completo`,
    serviceRequests: 'Richieste di servizio',
    inProgressRequests: 'In corso',
    totalCases: 'Casi totali',
    resolvedRequests: 'Risolti',
    viewDetails: 'Visualizza dettagli'
  }
};

export default dashboard;
